import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar.jsx";
import Spinner from "components/base/Spinner";
import { useState } from "react";
import { searchByProp } from "utils/search";

const FETCH_ALL_USERS = gql`
  query FETCH_ALL_USERS {
    allUsers {
      id
      firstName
      lastName
      email
      mainCustomer {
        id
        name
      }
    }
  }
`;

function UserSelector({ onSelectUser, fetchPolicy = "cache-first" }) {
  const [searchText, setSearchText] = useState("");
  const { loading, error, data } = useQuery(FETCH_ALL_USERS, {
    fetchPolicy,
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;
  const users = data.allUsers.filter((user) =>
    searchByProp(user, ["firstName", "lastName", "email"], searchText),
  );

  return (
    <div className="relative flex-1 flex-col flex">
      <div className="mb-4">
        <SearchBar
          autoFocus
          value={searchText}
          onChange={(text) => {
            setSearchText(text);
          }}
          placeholder="Search by email or name"
        />
      </div>
      {users.length > 0 && (
        <div className="flex-1">
          {users.map((user) => (
            <div
              className="cursor-pointer hover:text-sky-600 py-2 border-b dark:border-gray-700"
              key={user.id}
              onClick={() => onSelectUser(user)}
            >
              {user.email}{" "}
              {user.firstName && user.lastName ? (
                <span className="text-gray-500">
                  {user.firstName} {user.lastName}
                </span>
              ) : null}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default UserSelector;
